import { render, staticRenderFns } from "./RestaurantVicinity.vue?vue&type=template&id=91af95ae&"
import script from "./RestaurantVicinity.vue?vue&type=script&lang=js&"
export * from "./RestaurantVicinity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports